import React from 'react';

import { Card, Stack, Box, Heading, Columns, Column, Button } from '@origin-digital/ods-core';
import { formatCurrency } from '@origin-digital/formatters';
import { LocalPrintShopIcon } from '@origin-digital/icon';
import { isNative } from '@origin-digital/platform-helpers';

import {
  AddressDefinition,
  DivisionDefinition,
  ContractAccountDefinition,
  OrderDefinition,
  TimestampDefinition,
  ReferenceDefinition,
  PaymentDefinition,
} from 'src/components/Definition';

import { IProps } from './types';
import * as content from './content.json';

export const SummaryCard: React.SFC<IProps> = ({ context }) => {
  const {
    address,
    contractAccountId,
    divisionId,
    orderNumber,
    paymentData,
    paymentMethod,
    receiptNumber,
    timestamp,
  } = context;

  return (
    <Card data-id="summary-card">
      <Stack space={['large', 'xlarge']}>
        <Columns>
          <Column>
            <Heading variant="h4">{content.amountPaid}</Heading>
          </Column>
          <Column alignX="right">
            <Heading data-id="amount" variant="h2">
              {formatCurrency(parseFloat(context.amount.replace(/,/g, '')))}
            </Heading>
          </Column>
        </Columns>

        <Stack space="xsmall" dividers>
          <AddressDefinition address={address} />

          <DivisionDefinition divisionId={divisionId} />

          <ContractAccountDefinition
            divisionId={divisionId}
            contractAccountId={contractAccountId}
          />

          <OrderDefinition divisionId={divisionId} orderNumber={orderNumber} />

          <PaymentDefinition paymentData={paymentData} paymentMethod={paymentMethod} />

          <ReferenceDefinition receiptNumber={receiptNumber} />

          <TimestampDefinition timestamp={timestamp} />
        </Stack>

        {!isNative() && (
          <Box display="flex" justifyContent="center">
            <Button
              variant="text"
              color="secondary"
              size="small"
              onClick={window.print}
              data-id="print-button"
              icon={<LocalPrintShopIcon color="grey80" />}
            >
              {content.print}
            </Button>
          </Box>
        )}
      </Stack>
    </Card>
  );
};
